(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-recensioni-colore"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mb-rcol]') : null;
      if (!btn) return;
      var box = document.getElementById(btn.getAttribute('aria-controls'));
      if (!box) return;
      var apri = box.hidden;
      box.hidden = !apri;
      btn.setAttribute('aria-expanded', apri ? 'true' : 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-recensioni"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lb = null, img = null, conta = null, fotos = [], alts = [], idx = 0;

    function costruisci() {
      if (lb) return;
      lb = document.createElement('div');
      lb.className = 'mb-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.hidden = true;
      lb.innerHTML =
        '<button type="button" class="mb-lb__btn mb-lb__close" aria-label="Chiudi">&#10005;</button>' +
        '<button type="button" class="mb-lb__btn mb-lb__prev" aria-label="Foto precedente">&#8249;</button>' +
        '<img class="mb-lb__img" alt="">' +
        '<button type="button" class="mb-lb__btn mb-lb__next" aria-label="Foto successiva">&#8250;</button>' +
        '<span class="mb-lb__conta"></span>';
      document.body.appendChild(lb);
      img = lb.querySelector('.mb-lb__img');
      conta = lb.querySelector('.mb-lb__conta');

      lb.querySelector('.mb-lb__close').addEventListener('click', chiudi);
      lb.querySelector('.mb-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); vai(-1); });
      lb.querySelector('.mb-lb__next').addEventListener('click', function (e) { e.stopPropagation(); vai(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) chiudi(); });
    }

    function mostra() {
      img.src = fotos[idx];
      img.alt = alts[idx] || '';
      conta.textContent = (idx + 1) + ' / ' + fotos.length;
      lb.classList.toggle('mb-lb--una', fotos.length < 2);
    }

    function vai(d) {
      idx = (idx + d + fotos.length) % fotos.length;
      mostra();
    }

    function apri(btn) {
      costruisci();
      fotos = (btn.getAttribute('data-mb-fotos') || '').split('|').filter(Boolean);
      alts = (btn.getAttribute('data-mb-alts') || '').split('|');
      if (!fotos.length) return;
      idx = 0;
      mostra();
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function chiudi() {
      if (!lb) return;
      lb.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.mb-rec__foto--multi') : null;
      if (btn) { e.preventDefault(); apri(btn); }
    });

    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') chiudi();
      if (e.key === 'ArrowLeft') vai(-1);
      if (e.key === 'ArrowRight') vai(1);
    });

    /* CONTINUA: compare solo dove il testo supera le quattro righe. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mb-continua]') : null;
      if (!btn) return;
      var testo = btn.previousElementSibling;
      if (!testo) return;
      var aperto = testo.classList.toggle('is-open');
      btn.textContent = aperto ? 'Mostra meno' : 'Continua';
      btn.setAttribute('aria-expanded', aperto ? 'true' : 'false');
    });

    /* Tutte le schede alte come la piu' alta da chiuse. */
    function allinea(box) {
      var testi = box.querySelectorAll('[data-mb-testo]');
      for (var i = 0; i < testi.length; i++) {
        var t = testi[i];
        var b = t.nextElementSibling;
        if (!b || !b.hasAttribute('data-mb-continua')) continue;
        if (t.classList.contains('is-open')) { b.hidden = false; continue; }
        b.hidden = t.scrollHeight <= t.clientHeight + 2;
      }
      var schede = box.querySelectorAll('.mb-rec__card');
      var max = 0;
      for (var j = 0; j < schede.length; j++) schede[j].style.minHeight = '';
      for (var k = 0; k < schede.length; k++) {
        if (schede[k].querySelector('.mb-rec__testo.is-open')) continue;
        max = Math.max(max, schede[k].offsetHeight);
      }
      if (max) for (var m = 0; m < schede.length; m++) schede[m].style.minHeight = max + 'px';
    }

    /* CAROSELLO: le frecce spostano di una scheda per volta e si spengono
       quando si arriva in fondo. Se le schede ci stanno tutte, spariscono. */
    function giostra(box) {
      var scroller = box.querySelector('[data-mb-scroller]');
      var prev = box.querySelector('[data-mb-prev]');
      var next = box.querySelector('[data-mb-next]');
      var card = box.querySelector('.mb-rec__card');
      if (!scroller || !prev || !next) return;

      function passo() {
        if (!card) return scroller.clientWidth * 0.8;
        var stile = window.getComputedStyle(scroller.querySelector('.mb-rec__cards'));
        var gap = parseFloat(stile.columnGap || stile.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function aggiorna() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        var pieno = max <= 2;
        prev.disabled = pieno || scroller.scrollLeft <= 2;
        next.disabled = pieno || scroller.scrollLeft >= max - 2;
      }

      prev.addEventListener('click', function () { scroller.scrollBy({ left: -passo(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { scroller.scrollBy({ left: passo(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', aggiorna, { passive: true });
      window.addEventListener('resize', aggiorna);
      aggiorna();
      setTimeout(aggiorna, 400);

      allinea(box);
      window.addEventListener('resize', function () { allinea(box); });
      window.addEventListener('load', function () { allinea(box); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { allinea(box); });
      var imgs = box.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (!imgs[i].complete) imgs[i].addEventListener('load', function () { allinea(box); }, { once: true });
      }
    }

    function avvia() {
      var box = document.querySelectorAll('[data-mb-giostra]');
      for (var i = 0; i < box.length; i++) giostra(box[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', avvia);
    } else {
      avvia();
    }
    document.addEventListener('shopify:section:load', avvia);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-video-colore"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function avvia(e) {
      var btn = e.target.closest ? e.target.closest('.mb-vid__play') : null;
      if (!btn) return;
      var box = btn.closest('[data-mb-vid]');
      if (!box) return;
      var id = box.getAttribute('data-mb-vid');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = btn.getAttribute('aria-label') || 'Video YouTube';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      box.innerHTML = '';
      box.appendChild(f);
    }
    document.addEventListener('click', avvia);
  })();

  } catch(e) { console.error(e); }
})();
})();
